import { Context, useQuery } from '@apollo/client'
import { useRouter } from 'next/router'

import Layout from '@web/components/Layout'
import Loading from '@web/components/Loading'
import { gql } from '@web/gql'
import { ReviewGroupExposeStatus } from '@web/gql/graphql'
import { initializeApollo } from '@web/libs/apollo/client'
import { isTypename, extractByTypename } from '@web/libs/apollo/typeGuard'
import { DEFAULT_USER_NICKNAME } from '@web/libs/constants'
import OthersHideReviewContent from '@web/pages/review/components/ReviewDetail/ReviewContent/OthersHideReviewContent'

import NoContentReview from '../components/ReviewDetail/ReviewContent/NoContentReview/NoContentReview'
import ReviewDetail from '../components/ReviewDetail/ReviewDetail'

const query = gql(`
  query ReviewDetailPage($reviewGroupId: ID!) {
    reviewGroup(id: $reviewGroupId) {
      __typename
      ... on ReviewGroupSucceed {
        reviewGroup {
          author {
            profile {
              nickname
            }
          }
          visit {
            displayName
          }
          ...ReviewDetail_ReviewGroup
        }
      }
    }
    me {
      ... on MeSucceed {
        user {
          ...User_Profile
        }
      }
    }
  }
`)

const ReviewDetailPage = ({}) => {
  const router = useRouter()
  const reviewGroupId = router.query.reviewGroupId!.toString()

  const { data, loading, error } = useQuery(query, { variables: { reviewGroupId } }) || {}

  if (loading) return <Loading isPageType />

  if (error) throw error

  if (!data || !isTypename(data.reviewGroup, 'ReviewGroupSucceed')) {
    return (
      <Layout>
        <NoContentReview />
      </Layout>
    )
  }

  const { ReviewGroupSucceed } = extractByTypename(data.reviewGroup)

  if (ReviewGroupSucceed?.reviewGroup.exposeStatus === ReviewGroupExposeStatus.Unexpose) {
    return (
      <Layout>
        <OthersHideReviewContent />
      </Layout>
    )
  }

  const { reviewGroup } = data.reviewGroup
  const { ImageItem, VideoItem } = extractByTypename(data.reviewGroup.reviewGroup.mediaItems[0])

  const imageUrl = ImageItem?.url || VideoItem?.thumbnail
  const placeName = reviewGroup.place?.name ?? reviewGroup.visit?.displayName

  return (
    <Layout
      metaTagProps={{
        title: `${reviewGroup.author?.profile.nickname ?? DEFAULT_USER_NICKNAME}님의 ${placeName ?? ''} 리뷰`,
        author: reviewGroup.author?.profile.nickname ?? DEFAULT_USER_NICKNAME,
        description: reviewGroup.text,
        ...(imageUrl && { image: { url: imageUrl } }),
      }}
    >
      <ReviewDetail reviewGroup={reviewGroup} />
    </Layout>
  )
}

export async function getServerSideProps(context: Context) {
  const { reviewGroupId } = context.params
  const apolloClient = initializeApollo({ context })

  try {
    await apolloClient.query({ query, variables: { reviewGroupId } })

    return {
      props: {
        initialState: apolloClient.cache.extract(),
      },
    }
  } catch (e) {
    return {
      props: {
        initialState: null,
        hasError: true,
      },
    }
  }
}

export default ReviewDetailPage
